module.exports = __webpack_public_path__ + "img/Guangdong-power.5f74e316.png";